// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4362":"css/app.7030","6578":"css/admin-app.7030"}[chunkId] + ".css";
};